<template>
    <div class="child_indexBox">

        <el-table :data="tableData" border class="roster_table" style="width: 100%">
            <el-table-column prop="fullName" align="center" label-class-name="roster_th" class-name="roster_row"
                label="Full Name">
            </el-table-column>
            <el-table-column prop="emailAddress" align="center" label-class-name="roster_th" class-name="roster_row"
                label="Email Address">
            </el-table-column>
            <el-table-column prop="mobileNumber" align="center" label-class-name="roster_th" class-name="roster_row"
                label="Mobile Number">
            </el-table-column>
            <el-table-column prop="id" align="center" label-class-name="roster_th" class-name="roster_row" width="250"
                label="Functions">
                <template slot-scope="scope">
                    <div class="d-flex justify-content-center">
                        <el-button class="edit-button" @click="editRow(scope.row)">Edit</el-button>
                        <el-button class="delete-button" @click="delRow(scope.row.id)">Delete</el-button>
                    </div>
                </template>
            </el-table-column>
            <template slot="empty">
                <i v-if="load" class="el-icon-loading" style="font-size:20px"></i>
                <div v-else style="font-size:18px">No Data</div>
            </template>
        </el-table>
        <div class="ros_footerPage">
            <el-pagination class="my_pageSel" @current-change='changePage' layout="prev, pager, next" :page-size="10"
                :current-page.sync='page' :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="`${isEdit ? 'Edit' : 'Add new'} app account`" :visible.sync="show" :modal-append-to-body="false"
            :show-close="false" class="editCardDio" :close-on-click-modal="false" width="840px" center>
            <div>
                <el-form :model="ruleForm" label-position="top" :rules="rules" ref="ruleForm" label-width="100px"
                    class="app-ruleForm">
                    <el-form-item label="Full name" prop="fullName">
                        <el-input maxlength="50" v-model="ruleForm.fullName"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!isEdit" label="Email" prop="email">
                        <el-input maxlength="50" type="email" v-model="ruleForm.email"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!isEdit" label="Mobile numbers" prop="mobile" class="prefix-areacode">

                        <div class="d-flex align-items-center justify-content-center gap-5">
                            <el-dropdown trigger="click">
                                <el-button type="peiso-default">
                                    {{ areaCode }}
                                    <div class="img-container">
                                        <img src="@/assets/arrow-down.svg" alt="">
                                    </div>
                                </el-button>


                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item :class="{'active' : areaCode == '+61'}" @click.native="selectAreaCode('+61')">+61</el-dropdown-item>
                                        <el-dropdown-item :class="{'active' : areaCode == '+64'}" @click.native="selectAreaCode('+64')">+64</el-dropdown-item>
                                    </el-dropdown-menu>

                                </template>
                            </el-dropdown>
                            <el-input :maxlength="max" v-model="ruleForm.mobile" @input="detectInput"></el-input>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="cardCanBtn" @click="cancel">Cancel</el-button>
                <el-button class="cardConBtn" @click="save">Confirm <i v-if="uploading" class="el-icon-loading"
                        style="font-size:20px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog title="" :visible.sync="delDio" :modal-append-to-body="false" :show-close='false' class="delEmployDio"
            :close-on-click-modal='false' width="840px" center>
            <div class="delMsg-tit">
                After deletion, this account will not be able to view the current<br />
                venue data in the app. Are you sure you want to delete?
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelDelete" class="cardCanBtn">Cancel</el-button>
                <el-button @click="delConfirm" class="cardConBtn">Delete <i v-if="deleting" class="el-icon-loading"
                        style="font-size:20px"></i></el-button>
            </span>
        </el-dialog>

        <el-dialog class="peiso-modal message-error" :visible.sync="isError" :close-on-click-modal='false' center @close="closeMessage" width="840px">
            <span>You have already reached the maximum number of App accounts you may add</span>
        </el-dialog>

		<el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>

    </div>
</template>

<script>
import api from '../../api/api'
import Utils from '../../utils/utils';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    props: {
        addFlag: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        isPro: {
            default: null
        }
    },
    data() {
        return {
            tableData: [],
            total: 1,
            page: 1,
            size: 10,
            load: false,

            ruleForm: {
                fullName: null,
                email: null,
                mobile: null
            },
            rules: {
                fullName: [{ required: true, message: ' ', trigger: 'change' }],
                email: [{ required: false, message: ' ', trigger: 'change' }],
                mobile: [{ required: true, message: ' ', trigger: 'change' }]
            },

            uploading: false,
            isEdit: false,

            id: null,

            delDio: false,
            deleting: false,

            max: 11,
            areaCode: '+61',
            isError: false,
			venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
        }
    },
    mounted() {
        this.getlist()

		this.$root.$on('isPro', (isPro, others) => {

			const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
		})
    },
    computed: {
        show() {
            if (this.addFlag || this.isEdit)
                return true
            else
                return false
        }
    },
    methods: {
        detectInput() {
            this.ruleForm.mobile = this.ruleForm.mobile.replace(/[^\d]/g, '')
            if (this.ruleForm.mobile && this.ruleForm.mobile.charAt(0) === '0') {
                this.ruleForm.mobile = '';
            }

            this.max = 11;
            // if (this.ruleForm.mobile.slice(0, 1) === '0') {
            //     this.max = 10
            // } else {
            //     this.max = 9
            // }
        },
        editRow(row) {
            this.id = row.id
            this.isEdit = true
            this.ruleForm = {
                fullName: row.fullName,
                email: row.emailAddress ? row.emailAddress : '',
                mobile: row.mobileNumber.replace(/\s+/g, '')
            }
        },
        cancelDelete() {
            var that = this
            if (that.deleting)
                return
            that.delDio = false
        },
        delConfirm() {
            var that = this
            if (that.deleting)
                return
            that.deleting = true
            api.accountDeleteApi({
                params: {
                    id: that.id
                },
                callback: (res) => {
                    if (!res.data)
                        return
                    that.deleting = false
                    let { code, data, message } = res.data;
                    if (code == 0) {
                        that.getlist()
                        that.delDio = false
                        that.cancel()
                    } else {
                        Utils.alert2('', message, 'error')
                    }
                }
            })
        },
        delRow(id) {
            this.id = id
            this.delDio = true
        },
        changePage(page) {
            this.page = page
            this.getlist()
        },
        getlist() {
            this.load = true
            let pat = {
                pageNum: this.page,
                pageSize: this.size
            }
            api.appListApi(pat, res => {
                this.load = false
                let { code, data, message } = res.data;
                if (code == 0) {
                    data.list.forEach(item => {
                        item.mobileNumber = `${item.mobileNumber.slice(0, 4)} ${item.mobileNumber.slice(4, 7)} ${item.mobileNumber.slice(7)}`
                    })
                    this.total = data.total;
                    this.tableData = data.list;
                } else {
                    Utils.alert2('', message, 'error')
                }
            })
        },
        save() {
            var that = this
            if (that.uploading)
                return
            that.uploading = true
            that.$refs["ruleForm"].validate((valid) => {

                if (valid) {
                    if (!that.isEdit)
                        api.accountAddApi({
                            params: {
                                "fullName": that.ruleForm.fullName,
                                "emailAddress": that.ruleForm.email,
                                "mobileNumber": `0${that.ruleForm.mobile}`
                            },
                            callback: (res) => {
                                that.uploading = false
                                let { code, data, message } = res.data;
                                if (code == 0) {
                                    that.cancel()
                                    that.getlist()
                                    Utils.alert2('', 'Successfully saved. You will be notified via your registered email address and SMS.', 'success')
                                } else {
                                    Utils.alert2('', message, 'error')
                                }
                            }
                        })
                    else
                        api.accountEditApi({
                            params: {
                                "fullName": that.ruleForm.fullName,
                                "emailAddress": that.ruleForm.email,
                                "id": that.id
                            },
                            callback: (res) => {
                                that.uploading = false
                                let { code, data, message } = res.data;
                                if (code == 0) {
                                    that.cancel()
                                    that.getlist()
                                    Utils.alert2('', 'Successfully saved. You will be notified via your registered email address and SMS.', 'success')
                                } else {
                                    Utils.alert2('', message, 'error')
                                }
                            }
                        })
                } else {
                    that.uploading = false;
                    return false;
                }
            });
        },
        cancel() {
            var that = this
            if (that.uploading)
                return
            that.isEdit = false
            that.delDio = false
            that.$refs["ruleForm"].clearValidate();
            that.ruleForm = {
                fullName: null,
                mobile: null
            }
            that.$emit('close')
        },
        selectAreaCode(area) {
            this.areaCode = area
            console.log(this.areaCode)
        },
        closeMessage() {
            this.isError = false
            this.$emit('close')
        },

		closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}
    },
    watch: {
        addFlag(n, o) {
            if (n) {
                // this.$refs["ruleForm"].clearValidate();
                if (!this.isPro && this.tableData.length >= 2) {
                    this.isError = true
                }
            }
        },
    },
    components: {
        freeTrialNotice: freeTrialNotice
    }
}
</script>

<style lang="scss">
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
.child_indexBox {
    width: 100%;
    margin-top: 30px;

    .ros_footerPage {
        display: flex;
        justify-content: center;
    }

    padding-bottom: 50px;

    .edit-button {
        height: 40px;
        background: transparent;
        border-color: var(--secondary-color);
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--secondary-color);
        border-radius: 0;
        display: flex;
        align-items: center;
    }

    .delete-button {
        height: 40px;
        background: transparent;
        border-color: #D13A90;
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #D13A90;
        border-radius: 0;
        display: flex;
        align-items: center;
    }

    .delMsg-tit {
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: var(--text-color);
        line-height: 33px;
        margin-bottom: 15px;
    }

    .el-button--peiso-default {
        padding-right: 4rem;
        height: 50px;
    }

    .prefix-areacode {
        .el-input {
            .el-input__inner {
                padding-left: 1rem !important;
                font-size: 18px !important;
                font-weight: 700;
                color: var(--text-color);

                font-family: 'Montserrat', sans-serif !important;
            }
        }
    }

    .el-form-item {
        padding-left: 1rem !important;
        font-size: 18px !important;
        font-weight: 700;
        color: var(--text-color);


        .el-form-item__label {
            font-family: 'Montserrat', sans-serif !important;

        }

        .el-form-item__content {

            .el-input__inner {
                font-family: 'Montserrat', sans-serif !important;
                border-radius: 5px;
                border: none;
            }
        }
    }

    .message-error {
        .el-dialog__body {
            text-align: center;
            min-height: 250px;
            padding: 4rem !important;
            display: flex;
            align-items: center;
            span {
                @include montserrat-font(28px, 40px, 500, $white) {
                    word-break: normal;
                }
            }
        }
    }

    .el-dialog {
        .el-dialog__title {
            font-family: 'Montserrat', sans-serif !important;

        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/rosterAndLabour/app.vue